import { MONTH } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { PATHS_REPORTS_PAGE, ROUTE_REPORT_TIME_INTERVAL } from '../../../constants/app';
import { pageState } from '../../../storage/app';
import {
  activeReportAlarmState,
  activeReportRouteState,
  activeTelemetryState,
  deliveryAllDevicesState,
  deliveryDateState,
  evidenceAlarmFilterState,
  evidenceMediaTypeFilterState,
  evidenceOriginFilterState,
  pathDistanceFilterState,
  pathTimeFilterState,
  reportAlarmFilterState,
  reportEndDateState,
  reportFilterGroupState,
  reportIntervalState,
  reportIsManualIntervalState,
  reportMaxEndDateState,
  reportMinStartDateState,
  reportSelectedAssetIdsState,
  reportStartDateState,
  reportViewState,
} from '../../../storage/reports';
import { getEndDate, roundUpToNextIntervalTime } from '../../../utils/dates';

function useReportFilters() {
  const interval = useRecoilValue(reportIntervalState);
  const isManualInterval = useRecoilValue(reportIsManualIntervalState);
  const page = useRecoilValue(pageState);
  const isPathsReport = page === PATHS_REPORTS_PAGE.id;
  const resetActiveRoute = useResetRecoilState(activeReportRouteState);
  const resetActiveTelemetry = useResetRecoilState(activeTelemetryState);
  const resetActiveReportAlarm = useResetRecoilState(activeReportAlarmState);
  const resetAlarm = useResetRecoilState(evidenceAlarmFilterState);
  const resetDateDelivery = useResetRecoilState(deliveryDateState);
  const resetDeliveryAllDevices = useResetRecoilState(deliveryAllDevicesState);
  const resetEndDate = useResetRecoilState(reportEndDateState);
  const resetFilterGroup = useResetRecoilState(reportFilterGroupState);
  const resetInterval = useResetRecoilState(reportIntervalState);
  const resetIsManualInterval = useResetRecoilState(reportIsManualIntervalState);
  const resetMediaType = useResetRecoilState(evidenceMediaTypeFilterState);
  const resetOrigin = useResetRecoilState(evidenceOriginFilterState);
  const resetReportView = useResetRecoilState(reportViewState);
  const resetSelectedAssetIds = useResetRecoilState(reportSelectedAssetIdsState);
  const resetStartDate = useResetRecoilState(reportStartDateState);
  const setEndDate = useSetRecoilState(reportEndDateState);
  const setMaxEndDate = useSetRecoilState(reportMaxEndDateState);
  const setMinStartDate = useSetRecoilState(reportMinStartDateState);
  const setStartDate = useSetRecoilState(reportStartDateState);
  const resetReportAlarm = useResetRecoilState(reportAlarmFilterState);
  const resetPathTimeFilterState = useResetRecoilState(pathTimeFilterState);
  const resetPathDistanceFilterState = useResetRecoilState(pathDistanceFilterState);

  const resetFilters = (soft: boolean = false) => {
    resetInterval();
    resetIsManualInterval();
    resetSelectedAssetIds();
    resetReportView();
    resetFilterGroup();
    resetActiveRoute();
    resetActiveTelemetry();
    resetActiveReportAlarm();
    resetMediaType();
    resetOrigin();
    resetAlarm();
    resetReportAlarm();
    resetDateDelivery();
    resetDeliveryAllDevices();
    resetPathTimeFilterState();
    resetPathDistanceFilterState();
    if (soft) {
      setDates();
    } else {
      resetEndDate();
      resetStartDate();
    }
  };

  const setDates = () => {
    const now = isPathsReport && isManualInterval ? roundUpToNextIntervalTime() : Date.now();
    setEndDate(now);
    setStartDate(now - interval);
    if (isManualInterval) {
      const maxEndDate = getEndDate();
      setMinStartDate(maxEndDate - ROUTE_REPORT_TIME_INTERVAL * MONTH);
      setMaxEndDate(maxEndDate);
    }
  };

  return {
    resetFilters,
    setDates,
  };
}

export default useReportFilters;
